import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0064',
    ecrans: ['00-2'],
    params:['?unocleintrh','?trmcleint','?ofacleint', '?unocleint', '?isforage']
});
